<template>
    <div class="post-entry" v-html="this.news">
    </div>
</template>

<script>
    export default {
        props: [
            'news',
        ]
    }
</script>